import {Box, Center, Flex, Icon, Text} from '@chakra-ui/react'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import {
  updateCurrentProgress,
  updateType,
  updateCurrentIndexDragDropData,
  reset,
  updateIsShowFooter,
  updateAudio,
} from '@redux/paraphrase/paraphraseSlice'
import {useDispatch, useSelector} from 'react-redux'
import {ParaphraseProgressEnum, ParaphraseType} from '..'
import {ReactComponent as ArrowRightIcon} from '@assets/svgs/learn/arrow_right_6.svg'
import {ReactComponent as CheckIcon} from '@assets/svgs/check.svg'
import {ReactComponent as CloseIcon} from '@assets/svgs/close.svg'
import {useNavigate} from 'react-router-dom'
const Footer = () => {
  const {
    footerData,
    colorsParaphrase,
    isLoading,
    type,
    currentIndexDragDropData,
    isShowFooter,
    dragDropDataLength,
  } = useSelector((state: any) => state.paraphrase)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const onFinish = () => {
    dispatch(reset())
    navigate(-1)
  }

  if (type === ParaphraseType.SHOW_SENTENCE) {
    return (
      <Box
        className="paraphrase-footer"
        h={'180px'}
        bg={isLoading ? 'transparent' : '#fff'}
        p={{base: '16px', md: '32px'}}>
        {!isLoading && (
          <Center
            justifyContent={'space-between'}
            maxW={'1200px'}
            mx={'auto'}
            gap={'32px'}
            h={'100%'}>
            <Box>
              <Flex gap={'16px'} flexWrap={'wrap'}>
                {footerData &&
                  Array.isArray(footerData) &&
                  footerData.map((item, index) => (
                    <Text
                      key={`footer-item-${index}`}
                      fontSize={'16px'}
                      fontWeight={'600'}
                      color={colorsParaphrase?.[index]?.color ?? '#000'}
                      bg={colorsParaphrase?.[index]?.bg ?? 'transparent'}
                      border={`1px solid ${colorsParaphrase?.[index]?.color ?? '#000'}`}
                      borderRadius={'8px'}
                      p={'4px 8px'}
                      whiteSpace={'nowrap'}>
                      {item?.words || ''}
                    </Text>
                  ))}
              </Flex>
              <Text fontSize={'16px'} fontWeight={'500'} mt={'16px'}>
                Là các từ quyết định nghĩa của câu, bạn có thể paraphrase những
                từ này
              </Text>
            </Box>
            <GlobalButton
              w={'170px'}
              h={'48px'}
              isDisabled={isLoading}
              onClick={() => {
                dispatch(
                  updateCurrentProgress(ParaphraseProgressEnum.FIND_SYNONYM),
                )
                dispatch(updateType(ParaphraseType.FIND_SYNONYM))
              }}>
              Tiếp tục
            </GlobalButton>
          </Center>
        )}
      </Box>
    )
  }

  if (type === ParaphraseType.FIND_SYNONYM) {
    return (
      <Box
        className="paraphrase-footer"
        h={'180px'}
        bg={isShowFooter ? '#F6FFED' : 'transparent'}
        p={{base: '16px', md: '32px'}}>
        {isShowFooter && (
          <Center
            h={'100%'}
            justifyContent={'space-between'}
            maxW={'1200px'}
            mx={'auto'}
            gap={'32px'}>
            <Flex>
              <Text fontSize={'24px'} fontWeight={'600'} color={'#52C41A'}>
                Bạn đã kéo hết các từ vào ô đúng
              </Text>
            </Flex>
            <GlobalButton
              h={'48px'}
              w={'170px'}
              rightIcon={<Icon as={ArrowRightIcon} w={'20px'} h={'20px'} />}
              borderRadius={'16px'}
              bg={'#52C41A'}
              color={'#fff'}
              _hover={{bg: '#52C41A'}}
              onClick={() => {
                if (currentIndexDragDropData < dragDropDataLength - 1) {
                  dispatch(
                    updateCurrentIndexDragDropData(
                      currentIndexDragDropData + 1,
                    ),
                  )
                } else {
                  dispatch(
                    updateCurrentProgress(ParaphraseProgressEnum.SELECT_ANSWER),
                  )
                  dispatch(updateType(ParaphraseType.SELECT_ANSWER))
                  dispatch(updateIsShowFooter(false))
                }
              }}>
              Tiếp tục
            </GlobalButton>
          </Center>
        )}
      </Box>
    )
  }

  if (type === ParaphraseType.SELECT_ANSWER) {
    return (
      <Box
        h={'180px'}
        bg={
          isShowFooter
            ? footerData?.is_correct
              ? '#F6FFED'
              : '#FFF5F4'
            : 'transparent'
        }
        p={{base: '16px', md: '32px'}}>
        {isShowFooter && (
          <Center
            h={'100%'}
            justifyContent={'space-between'}
            maxW={'1200px'}
            mx={'auto'}
            gap={'32px'}>
            <Flex gap={'24px'} alignItems={'center'}>
              <Center w={'64px'} h={'64px'} borderRadius={'50%'} bg={'#fff'}>
                <Icon
                  as={footerData?.is_correct ? CheckIcon : CloseIcon}
                  w={'40px'}
                  h={'40px'}
                  sx={{
                    path: {
                      stroke: footerData?.is_correct ? '#73D13D' : '#ED4E42',
                      fill: footerData?.is_correct ? 'unset' : '#ED4E42',
                    },
                  }}
                />
              </Center>
              <Box>
                <Text
                  fontSize={'24px'}
                  fontWeight={'600'}
                  color={footerData?.is_correct ? '#52C41A' : '#ED4E42'}
                  mb={'8px'}>
                  {footerData?.is_correct ? 'Chính xác' : 'Sai rồi bạn nhé'}
                </Text>
                {footerData?.is_correct ? (
                  <Flex gap={'32px'} flexWrap={'wrap'}>
                    {footerData?.feedback.map((item: any, index: number) => (
                      <Text
                        key={index}
                        fontSize={'16px'}
                        fontWeight={'600'}
                        color={colorsParaphrase[item?.highlight_index]?.color}
                        border={`1px solid ${colorsParaphrase[item?.highlight_index]?.color}`}
                        bg={colorsParaphrase[item?.highlight_index]?.bg}
                        borderRadius={'8px'}
                        p={'4px 8px'}>
                        {item.text}
                      </Text>
                    ))}
                  </Flex>
                ) : (
                  <Text fontSize={'16px'}>{footerData?.feedback || ''}</Text>
                )}
              </Box>
            </Flex>
            <GlobalButton
              h={'48px'}
              w={'170px'}
              rightIcon={<Icon as={ArrowRightIcon} w={'20px'} h={'20px'} />}
              borderRadius={'16px'}
              bg={'#52C41A'}
              color={'#fff'}
              _hover={{bg: '#52C41A'}}
              onClick={() => {
                dispatch(
                  updateCurrentProgress(
                    ParaphraseProgressEnum.PRACTICE_SPEAKING,
                  ),
                )
                dispatch(updateType(ParaphraseType.PRACTICE_SPEAKING))
                dispatch(
                  updateAudio({
                    time: Date.now(),
                    url: '',
                  }),
                )
              }}>
              Tiếp tục
            </GlobalButton>
          </Center>
        )}
      </Box>
    )
  }

  if (type === ParaphraseType.SUMMARY) {
    return (
      <Box
        h={'180px'}
        bgGradient={'linear(to-r, #FFF6E9, #FFF1DE)'}
        p={{base: '16px', md: '32px'}}>
        <Center h={'100%'} justifyContent={'end'} maxW={'1200px'} mx={'auto'}>
          <GlobalButton
            bgGradient={'linear(to-r, #FF8008, #FFA034)'}
            color={'#fff'}
            _hover={{
              bgGradient: 'linear(to-r, #FF7000, #FF9124)',
            }}
            h={'48px'}
            w={'150px'}
            onClick={onFinish}>
            Hoàn thành
          </GlobalButton>
        </Center>
      </Box>
    )
  }

  return <></>
}

export default Footer
